import React, { useEffect, useState } from "react";
import { Button, Dialog, PlusIcon, SearchInput, Text, TextInput } from "evergreen-ui";
import { Card, Select, Table, message } from "antd";
import Firebase from "../../../Firebase/Firebase";
import { MDBBox, MDBCol, MDBRow } from "mdbreact";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { invalidateDemoData, useListVals } from "../../../Firebase/databaseHooks";
import { getDatabase, ref, update } from "firebase/database";
import InitiativeUpload from "../../../Modals/UploadModals/InitiativeUpload";
import TableActionMenu from "../../../Common/TableActionMenu";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

var db = getDatabase(Firebase);
const InitiativeLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: 'Initiative',
			dataIndex: 'initiative',
			key: 'initiative',
			sorter: {
				compare: (a, b) => a.initiative && a.initiative.localeCompare(b.initiative),
			}
		},
		{
			title: 'Code',
			dataIndex: 'code',
			key: 'code',
			sorter: {
				compare: (a, b) => a.code - b.code,
			}
		},
		{
			title: 'Sector',
			dataIndex: 'sector',
			key: 'sector',
			sorter: {
				compare: (a, b) => a.sector && a.sector.localeCompare(b.sector),
			}
		},
		{
			title: 'Language',
			dataIndex: 'language',
			key: 'language',
			sorter: {
				compare: (a, b) => a.language && a.language.localeCompare(b.language),
			}
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
		}
	]

	const [initiativeArray, setInitiativeArray] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/initiatives"));
	const [showModal, setShowModal] = useState(false);
	const [langArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [selectedLang, setSelectedLang] = useState(null);
	const [name, setName] = useState(null);
	const [code, setCode] = useState(null);
	const [selectedInitiate, setSelectedInitiate] = useState(null);
	const [searchValue, setSearchValue] = useState(null);
	const [selectedSector, setSelectedSector] = useState(null);
	const [sectors] = useListVals(ref(db, "talmidsdb/initiativeTypes"));
	const [uploadModal, setUploadModal] = useState(false);

	const getLanguageName = (languageId) => {
		const language = langArray.find((item) => item.languageID === languageId || item.id === languageId);
		return language?.language || language?.languageName || languageId || "";
	};

	const getSectorName = (sectorId) => {
		const sector = sectors.find((item) => item.id === sectorId || item.programID === sectorId);
		return sector?.name || sector?.initiativeProgram || sectorId || "";
	};

	const handleLang = (value) => {
		setSelectedLang(value);
	}
	const handleSector = (value) => {
		setSelectedSector(value);
	}

	useEffect(() => {
		var tempArray = [];
		if (arrayIn) {
			arrayIn.map((item, index) => {
				tempArray.push({
					key: index,
					initiative: item.title || item.initiative,
					id: item.id,
					code: item.code,
					language: getLanguageName(item.languageId || item.language),
					sector: getSectorName(item.sector || item.initiativeSector),
					action: (
						<TableActionMenu
							items={[
								canUpdate && {
									key: "edit",
									label: "Edit",
									onClick: () => {
										setSelectedInitiate(item); setSelectedSector(item.sector || item.initiativeSector);
										setName(item.title || item.initiative); setCode(item.code || ""); setSelectedLang(item.languageId || item.language);
										setShowModal(true);
									},
								},
								canDelete && {
									key: "delete",
									label: "Delete",
									danger: true,
									onClick: () => {
										if (confirm("Delete this initiative?")) {
											props.messageBack("initiatives", "delete", item.id);
										}
									},
								},
							]}
						/>
					)
				})
			});

			setInitiativeArray([...tempArray]);
			setDataArray([...tempArray]);
		}



	}, [arrayIn, langArray, props, canUpdate, canDelete, sectors]);

	const handleUpdate = () => {
		if (!canUpdate) {
			message.error("You do not have permission to update initiatives.");
			return;
		}

		const trimmedName = name?.trim();
		const trimmedCode = code?.trim();
		const selectedLanguage = langArray.find((item) => item.languageID === selectedLang || item.id === selectedLang);
		const selectedSectorItem = sectors.find((item) => item.id === selectedSector || item.programID === selectedSector);
		var object = {
			"title": trimmedName,
			"initiative": trimmedName,
			"languageId": selectedLang,
			"language": selectedLang,
			"languageName": selectedLanguage?.language || selectedLanguage?.languageName || "",
			"sector": selectedSector,
			"initiativeSector": selectedSector,
			"sectorName": selectedSectorItem?.name || "",
			"code": trimmedCode
		}


		update(ref(db, "talmidsdb/initiatives/" + selectedInitiate.id), object).then(() => {
			invalidateDemoData([
				"talmidsdb/initiatives",
				"talmidsdb/initiatives/" + selectedInitiate.id,
			]);
			FireFetch.addLog("Initiatives", selectedInitiate.id, "Edit");
			message.success("Initiative updated successfully");
			setShowModal(false);
		})
			.catch((error) => {
				message.error("unable to update Initiative");
			})

	}

	const handleSearch = searchText => {
		searchText = searchText.toLowerCase();
		setSearchValue(searchText);
		const filteredEvents = dataArray.filter(({ initiative, code, sector, language }) => {
			initiative = initiative && initiative.toLowerCase();
			sector = sector && sector.toLowerCase();
			code = String(code).toLowerCase();
			language = language && language.toLowerCase();
			return (initiative && initiative.includes(searchText)) || code.includes(searchText) ||
				(sector && sector.includes(searchText)) || (language && language.includes(searchText));
		});

		setInitiativeArray(filteredEvents);
	};

	return (
		<div className="font-Nunito">
			<Dialog
				isShown={showModal}
				title={"Edit Initiative"}
				onCloseComplete={() => { setShowModal(false); }}
				hasFooter={false}
			>
				<MDBBox>
					<MDBRow>
						<MDBCol md={12} className="d-flex flex-column">
							<div>
								<MDBRow>
									<MDBCol>
										<div className="d-flex flex-column">
											<div className="d-flex flex-column my-2 mt-3">
												<Text className=" mb-1">Enter new initiative Name</Text>
												<TextInput
													className="w-100"
													name="text-input-name"
													placeholder="enter initiative"
													onChange={(e) => { setName(e.target.value) }}
													value={name}
												/>
											</div>

											<div className="d-flex flex-column my-2">
												<Text className=" mb-1">Enter new initiative Code</Text>
												<TextInput
													className="w-100"
													name="text-input-name"
													placeholder="enter initiative"
													onChange={(e) => { setCode(e.target.value) }}
													value={code}
												/>
											</div>
											<div className="d-flex flex-column my-2">
												<Text className=" mb-1">Select new Initiative Language</Text>
												<Select placeholder="Select Language"
													value={selectedLang}
													showSearch
													optionFilterProp="children"
													filterOption={filterSelectOption}
													filterSort={sortSelectOptions}
													onChange={handleLang}>
													{langArray.map((item, index) => (
														<Select.Option key={index} value={item.languageID || item.id}>
															{item.language || item.languageName}
														</Select.Option>
													))}

												</Select>
											</div>

											<div className="d-flex flex-column my-2">
												<Text className=" mb-1">Select Initiative Sector</Text>
												<Select placeholder="Select Initiative Sector"
													value={selectedSector}
													showSearch
													optionFilterProp="children"
													filterOption={filterSelectOption}
													filterSort={sortSelectOptions}
													onChange={handleSector}>
													{sectors.map((item, index) => (
														<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
													))}

												</Select>
											</div>


										</div>
										<Button appearance="primary" className="mt-3" onClick={() => {
											handleUpdate();
										}}>Update</Button>
									</MDBCol>
								</MDBRow>
							</div>
						</MDBCol>
					</MDBRow>
				</MDBBox>

			</Dialog>
			<div className="d-flex flex-row align-items-center">
				<SearchInput placeholder="Filter through initiative name, code, sector & language" onChange={e => handleSearch(e.target.value)} value={searchValue} />
				{canCreate && (
					<Button appearance="primary" className="ml-3  my-2" onClick={() => { props.messageBack("Initiatives", "create") }}>
						New Initiative <PlusIcon className="ml-1" />
					</Button>
				)}
				<Button appearance="primary" className="mx-2" onClick={() => {
					FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
						filename: "Initiative",
						exportButtons: false,
						sheetname: "Initiative",
					}), initiativeArray);
				}}>
					Print
				</Button>
				{canCreate && (
					<Button className="mx-1 my-2"
						onClick={() => { setUploadModal(!uploadModal) }}>
						Upload
					</Button>
				)}
			</div>
			<InitiativeUpload showModal={uploadModal} name={"Initiatives"} id={"initiative"} />
			<Card className="d-flex flex-column">

				<div>
					<Table style={{ overflow: "auto" }} loading={loading}
						pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
						id={"dataTable"} dataSource={initiativeArray} columns={columns} />
				</div>
			</Card>
		</div>

	);
}
export default InitiativeLayout;
